var map = {
	"./default/ilustrations/1 copy.png": "./src/assets/themes/default/ilustrations/1 copy.png",
	"./default/ilustrations/1.png": "./src/assets/themes/default/ilustrations/1.png",
	"./default/ilustrations/2 copy.png": "./src/assets/themes/default/ilustrations/2 copy.png",
	"./default/ilustrations/2.png": "./src/assets/themes/default/ilustrations/2.png",
	"./default/ilustrations/3.png": "./src/assets/themes/default/ilustrations/3.png",
	"./default/ilustrations/4.png": "./src/assets/themes/default/ilustrations/4.png",
	"./default/ilustrations/5.png": "./src/assets/themes/default/ilustrations/5.png",
	"./default/ilustrations/6.png": "./src/assets/themes/default/ilustrations/6.png",
	"./default/logo-login.png": "./src/assets/themes/default/logo-login.png",
	"./default/logo-sidebar.png": "./src/assets/themes/default/logo-sidebar.png",
	"./default/wa-background.png": "./src/assets/themes/default/wa-background.png",
	"./urbe/ilustrations/1.png": "./src/assets/themes/urbe/ilustrations/1.png",
	"./urbe/ilustrations/2.png": "./src/assets/themes/urbe/ilustrations/2.png",
	"./urbe/ilustrations/3.png": "./src/assets/themes/urbe/ilustrations/3.png",
	"./urbe/ilustrations/4.png": "./src/assets/themes/urbe/ilustrations/4.png",
	"./urbe/ilustrations/5.png": "./src/assets/themes/urbe/ilustrations/5.png",
	"./urbe/ilustrations/6.png": "./src/assets/themes/urbe/ilustrations/6.png",
	"./urbe/ilustrations/7.png": "./src/assets/themes/urbe/ilustrations/7.png",
	"./urbe/ilustrations/8.png": "./src/assets/themes/urbe/ilustrations/8.png",
	"./urbe/ilustrations/9.png": "./src/assets/themes/urbe/ilustrations/9.png",
	"./urbe/logo-login.png": "./src/assets/themes/urbe/logo-login.png",
	"./urbe/logo-sidebar.png": "./src/assets/themes/urbe/logo-sidebar.png",
	"./urbe/wa-background.png": "./src/assets/themes/urbe/wa-background.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/themes sync recursive ^\\.\\/.*\\/.*$";